import React from 'react';
import {Link} from "react-router-dom";
import {useTranslation} from 'react-i18next';
import {useUiVersion} from "../../context/UserModulesContext";
import {useAccessAttention} from "../layout/v2/useAccessAttention";

export const CONNECTIONS_TAB_PLATFORMS = 'platforms';
// Sólo la 2.1 la dibuja (tanda «Agencia 2.1», D1): `/agency/ad-accounts` re-enmarcada como pestaña.
export const CONNECTIONS_TAB_ACCOUNTS = 'accounts';
export const CONNECTIONS_TAB_EXPORT = 'export';

// Las opciones del segmentado de la 2.1, en orden. Cuentas es la misma ruta de siempre, re-enmarcada
// SIN redirigir (D1): como `/sheets-sync` dentro de Exportación.
const CONNECTIONS_OPTIONS = [
    {key: CONNECTIONS_TAB_PLATFORMS, to: '/agency/conections', labelKey: 'agency_connections.tabs.platforms'},
    {key: CONNECTIONS_TAB_ACCOUNTS, to: '/agency/ad-accounts', labelKey: 'agency_connections.tabs.accounts'},
    {key: CONNECTIONS_TAB_EXPORT, to: '/agency/conections/export', labelKey: 'agency_connections.tabs.export'},
];

/**
 * Las pestañas de Conexiones (D9 del recorrido de la 2.1, 02/10): «Plataformas» —las cuentas y
 * los accesos de siempre— y «Exportación» —lo que SACA datos de Dashbo: el conector de Data Studio,
 * el Nodo de Datos y la exportación a planillas—. Es el mismo objeto que las sub-pestañas de
 * Personalización (`PersonalizationSubTabs`): una fila de `tabs` debajo de las de la agencia, con
 * cada pestaña en su propia ruta.
 *
 * En la 2.1 (tanda «Agencia 2.1», D3) son un segmentado y suman «Cuentas» en el medio. Plataformas
 * lleva un punto rojo si hay accesos por reconectar —la misma señal que el banner global y el
 * desplegable de la agencia— y Cuentas va sin contador. El clásico sigue con sus dos pestañas.
 *
 * `actions` (opcional, sólo la 2.1): la acción principal de la pestaña —«Conectar una plataforma»,
 * «Conectar una cuenta a un cliente»—, en la MISMA fila del segmentado y a la derecha, como en el
 * mockup. El clásico la ignora.
 */
export function ConnectionsSubTabs({activeSubTab, actions = null}) {
    // La misma decisión que el marco (`LayoutSidebar`): las sub-solapas nunca discrepan del riel.
    const {isV2} = useUiVersion();
    if (isV2) return <ConnectionsSegmented activeSubTab={activeSubTab} actions={actions}/>;
    return <ConnectionsSubTabsClassic activeSubTab={activeSubTab}/>;
}

function ConnectionsSubTabsClassic({activeSubTab}) {
    const {t} = useTranslation();
    const activeClass = activeSubTab === CONNECTIONS_TAB_EXPORT ? '-second' : '-first';

    return (
        <div className="filters">
            <ul className={'tabs ' + activeClass}>
                <li key={CONNECTIONS_TAB_PLATFORMS}>
                    <Link className="tab-button" to="/agency/conections">
                        {t('agency_connections.tabs.platforms')}
                    </Link>
                </li>
                <li key={CONNECTIONS_TAB_EXPORT}>
                    <Link className="tab-button" to="/agency/conections/export">
                        {t('agency_connections.tabs.export')}
                    </Link>
                </li>
            </ul>
        </div>
    );
}

function ConnectionsSegmented({activeSubTab, actions}) {
    const {t} = useTranslation();
    const attention = useAccessAttention();

    return (
        <div className="agv2-subnav">
            <nav className="uiseg" aria-label={t('sidebar_v2.connections')}>
                {CONNECTIONS_OPTIONS.map((option) => {
                    const active = option.key === activeSubTab;
                    return (
                        <Link key={option.key} to={option.to}
                              className={`uiseg__btn${active ? ' -active' : ''}`}
                              aria-current={active ? 'page' : undefined}>
                            {t(option.labelKey)}
                            {option.key === CONNECTIONS_TAB_PLATFORMS && attention > 0 && (
                                <span className="uiseg__dot" role="img"
                                      aria-label={t('agency_v2.frame.attention', {count: attention})}/>
                            )}
                        </Link>
                    );
                })}
            </nav>
            {actions && (
                <>
                    <span className="agv2-subnav__spacer"/>
                    {actions}
                </>
            )}
        </div>
    );
}
